export const AUTH_SUCCESS='AUTH_SUCCESS'
export const TOGGLE_LOADER = 'TOGGLE_LOADER'
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS'
export const VALIDATE_OTP_FAILURE = 'VALIDATE_OTP_FAILURE'
export const LOGOUT = 'LOGOUT'
export const HIDE_SNACK = 'HIDE_SNACK'
export const SHOW_SNACK = 'SHOW_SNACK'
export const GET_ALL_LEADS = 'GET_ALL_LEADS'